import React from 'react';
import PropTypes from 'prop-types';

import {
  CheckboxGroup,
  H3,
  Panel,
  PanelBody,
  PanelHeader,
  PanelSection,
  PanelSectionTitle,
  PanelTitle,
} from '@studio/legacy-components';

import RedirectAction from './RedirectAction';
import TriggerAction from './TriggerAction';
import { HelpText } from './styled';

export const Actions = ({
  appId,
  id,
  nextContentId = '',
  onSave,
  schemeLink = '',
}) => {
  return (
    <Panel>
      <PanelHeader>
        <PanelTitle>
          <H3>Actions</H3>
        </PanelTitle>
      </PanelHeader>
      <PanelBody>
        <PanelSection>
          <PanelSectionTitle>
            What should we do when this Flow has been completed?
          </PanelSectionTitle>
          <CheckboxGroup>
            <RedirectAction onSave={onSave} schemeLink={schemeLink} />
            <TriggerAction
              appId={appId}
              id={id}
              nextContentId={nextContentId}
              onSave={onSave}
            />
          </CheckboxGroup>
          <HelpText>
            These actions won’t be triggered during preview, but they will work
            in the live Flow.
          </HelpText>
        </PanelSection>
      </PanelBody>
    </Panel>
  );
};

Actions.propTypes = {
  appId: PropTypes.string,
  id: PropTypes.string,
  nextContentId: PropTypes.string,
  onSave: PropTypes.func,
  schemeLink: PropTypes.string,
};

export default Actions;
